export function testimonialsSlider() {
    let $slider = $(".testimonials-slider");
    let $sliderNav = $(".testimonials-slider-nav");

    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: false,
        arrows: false,
        infinite: false,
        asNavFor: $sliderNav,
    });

    $sliderNav.slick({
        slidesToShow: 2.9,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        asNavFor: $slider,
        infinite: false,
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                }
            },
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialsSlider.js